import axios_instance from '../utilities/axios_instance';

const URL = "fieldControl";

const FieldControlProvisionsService = {
  
  getAllProvisions: async (search_criteria, clb) => {
    try {
      const {user, farmer, season, field, phase, search_query, page, pageSize, startDate, endDate, where} = search_criteria
      let query = "";
      query += search_query ? `search_query=${search_query}&` : "";
      query += user ? `userId=${user}&` : "";
      query += farmer ? `farmerId=${farmer}&` : "";
      query += season ? `seasonId=${season}&` : "";
      query += field ? `fieldId=${field}&` : "";
      query += phase ? `phase=${phase}&` : "";
      query += startDate ? `startDate=${startDate}&` : "";
      query += endDate ? `endDate=${endDate}&` : "";
      query += page || page ? `page=${page}&` : "";
      query += pageSize || pageSize ? `pageSize=${pageSize}` : "";

      const response = await axios_instance.get(`${URL}?${query}`);
      const fieldControls = response.data.data.fieldControls;
      const {count, rows} = fieldControls.length !== 0 ? fieldControls : {count: 0, rows: []};

      const provisions = rows; 
      const _prov_data = provisions.map((d, idx) => {
        let p = {...d.data}; // FIXME - there is a bug in update Provision  - AGCC-189
        p.field = d.field;
        p.farmer = d.field.farmer;
        p.fieldId = d.fieldId;
        p.id = d.id;
        p.updatedAt = d.updatedAt;
        p.createdAt = d.createdAt;
        p.user = d.user;
        p.userId = d.userId;
        p.season = d.season;
        return p
      })

      clb({data: _prov_data, count});
    } catch (error) {
      console.error(error);
    }
  },

  getProvisionsFilteredStats: async (search_criteria, clb) => {
    try {
      const {user, farmer, season, /*field,*/ phase, search_query, page, pageSize/*, where*/} = search_criteria
      let query = "";
      query += search_query ? `search_query=${search_query}&` : "";
      query += user ? `userId=${user}&` : "";
      query += farmer ? `farmerId=${farmer}&` : "";
      query += season ? `seasonId=${season}&` : "";
      //query += field ? `fieldId=${field}&` : "";
      query += phase ? `phase=${phase}&` : "";
      query += page || page ? `page=${page}&` : "";
      query += pageSize || pageSize ? `pageSize=${pageSize}` : "";

      const response = await axios_instance.get(`${URL}/filtered_stats/?${query}`);
      const stats = response.data.data.fieldControls;

      clb(stats);
    } catch (error) {
      console.error(error);
    }
  },

  getProvisionsForField: async (field_id) => {
    try {
      const response = await axios_instance.get(`${URL}/?fieldId=${field_id}`);
      const provisions = response.data.data.fieldControls;
      const _prov_data = provisions.map((d, idx) => {
        
        let p = {...d.data}; // FIXME - there is a bug in update Provision  - AGCC-189
        p.field = d.field;
        p.farmer = d.field.farmer;
        p.fieldId = d.fieldId;
        p.id = d.id;
        p.updatedAt = d.updatedAt;
        p.createdAt = d.createdAt;
        p.user = d.user;
        p.userId = d.userId;
        p.season = d.season;
        return p
      })
      return _prov_data;
    } catch (error) {
      console.error(error);
    }
  },

  getProvisionsForFieldForSeason: async (field, season, page, pageSize, _clb) => {
    
    try {
      FieldControlProvisionsService.getAllProvisions({field: field, season:season, page: page, pageSize: pageSize}, (data) => {
        _clb(data)

      })
      // const response = await axios_instance.get(`${URL}/?fieldId=${field_id}`);
      // const provisions = response.data.data.fieldControls;

      
      // console.log("PROVISIONS: ", provisions);
      // const _prov_data = provisions.map((d, idx) => {
        
      //   let p = {...d.data}; // FIXME - there is a bug in update Provision  - AGCC-189
      //   p.field = d.field;
      //   p.farmer = d.field.farmer;
      //   p.fieldId = d.fieldId;
      //   p.id = d.id;
      //   p.updatedAt = d.updatedAt;
      //   p.createdAt = d.createdAt;
      //   p.user = d.user;
      //   p.userId = d.userId;
      //   p.season = d.season;
      //   return p
      // })

      // return _prov_data.filter(p => p.season.id === season_id);
    } catch (error) {
      console.error(error);
    }
  },

  createProvision: async (field_id, date, body) => {
    try {
      const response = await axios_instance.post(`${URL}/?fieldId=${field_id}&date=${date}`, body);

      return response.data.data.fieldControl;
    } catch (error) {
      console.error(error);
    }
  },

  updateProvision: async (provision_id, body ) => {
    try {
      console.log("BOYDDDD: ", body);
      const response = await axios_instance.put(`${URL}/${provision_id}`, body);

      return response.data.data.fieldControl;
    } catch (error) {
      console.error(error);
    }
  },

  deleteProvision: async (provision_id) => {
    try {
      const response = await axios_instance.delete(`${URL}/${provision_id}`);

      return response.data.data.fieldControl;
    } catch (error) {
      console.error(error);
    }
  },

  getProvision: async (provision_id) => {
    try {
      const response = await axios_instance.get(`${URL}/${provision_id}`);
      const _prov = response.data.data.fieldControl; 

      let p = {..._prov.data}; // FIXME - there is a bug in update Provision 
      p.field = _prov.field;
      p.farmer = _prov.field.farmer;
      p.fieldId = _prov.fieldId;
      p.id = _prov.id;
      p.updatedAt = _prov.updatedAt;
      p.createdAt = _prov.createdAt; 
      p.user = _prov.user;
      p.userId = _prov.userId;
      p.season = _prov.season;
      if (typeof p.soil_analysis_images === 'string') {
        try {
          p.soil_analysis_images = JSON.parse(p.soil_analysis_images);
        } catch (error) {
          p.soil_analysis_images = [];
        }
      }
      if (typeof p.field_visit_images === 'string') {
        try {
          p.field_visit_images = JSON.parse(p.field_visit_images);
        } catch (error) {
          p.field_visit_images = [];
        }
      }
      p.soil_analysis_images = p.soil_analysis_images || [];
      p.field_visit_images = p.field_visit_images || [];
      console.log("Provision images loaded:", {
        soil_analysis_images: p.soil_analysis_images,
        field_visit_images: p.field_visit_images
      });
      return { ...p };
    } catch (error) {
      console.error(error);
    }
  }
};

export default FieldControlProvisionsService;
